import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {DueDiligenceItemComponent} from "./due-diligence-subcomponents/due-diligence-item/due-diligence-item.component";
import {DueDiligenceComponent} from "./due-diligence.component";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatExpansionModule} from "@angular/material/expansion";
import {MatIconModule} from "@angular/material/icon";
import {MatSelectModule} from "@angular/material/select";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatButtonModule} from "@angular/material/button";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatInputModule} from "@angular/material/input";
import { DueDiligenceAddDateModalComponent } from './due-diligence-subcomponents/due-diligence-add-date-modal/due-diligence-add-date-modal.component';
import {MatDialogModule} from "@angular/material/dialog";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatDividerModule} from "@angular/material/divider";



@NgModule({
  declarations: [
    DueDiligenceItemComponent,
    DueDiligenceComponent,
    DueDiligenceAddDateModalComponent
  ],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatExpansionModule,
    MatIconModule,
    MatSelectModule,
    MatCheckboxModule,
    MatButtonModule,
    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatDatepickerModule,
    MatDividerModule
  ]
})
export class DueDiligenceModule { }
